import { Domain } from "@/types/domain";

export const midstreamDomains: Domain[] = [
  {
    symbol: "Pipe",
    name: "Pipeline Engineering",
    categories: "Pipeline Route Optimization, Material Selection, Stress Analysis, Corrosion Prevention"
  },
  {
    symbol: "Pops",
    name: "Pipeline Operations",
    categories: "Flow Monitoring, Leak Detection, Pipeline Integrity, Maintenance Planning"
  },
  {
    symbol: "Gasp",
    name: "Gas Processing & Transport",
    categories: "NGL Separation, Gas Compression, LNG Transport, Gas Hydrate Management"
  },
  {
    symbol: "Stor",
    name: "Storage & Terminal Ops",
    categories: "Crude Storage Design, Tank Farm Safety, LNG Storage, Terminal Optimization"
  },
  {
    symbol: "Hsem",
    name: "HSE Compliance",
    categories: "Environmental Assessments, Pipeline Safety, Emergency Response, Regulatory Compliance"
  },
  {
    symbol: "Scml",
    name: "Supply Chain & Logistics",
    categories: "Transport Scheduling, Inventory Management, Distribution Networks, Logistics Optimization"
  },
  {
    symbol: "Asst",
    name: "Asset Integrity",
    categories: "Corrosion Monitoring, Non-Destructive Testing, Risk-Based Inspection, Pipeline Tools"
  },
  {
    symbol: "Auto",
    name: "Automation & Control",
    categories: "SCADA Systems, Gas Compression Automation, Remote Monitoring, Predictive Analytics"
  },
  {
    symbol: "Regc",
    name: "Regulatory Compliance",
    categories: "Pipeline Safety, FERC Compliance, Environmental Reporting, Global Standards"
  },
  {
    symbol: "Risk",
    name: "Risk Management",
    categories: "Leak Response, Risk Assessment, Crisis Management, Emergency Shutdown"
  },
  {
    symbol: "Ccus",
    name: "CCUS in Midstream",
    categories: "CO2 Transport, Carbon Sequestration, Safety Protocols, Gas Processing Integration"
  },
  {
    symbol: "Lngi",
    name: "LNG Infrastructure",
    categories: "LNG Facility Design, Shipping Operations, Storage Optimization, Safety Protocols"
  },
  {
    symbol: "Sust",
    name: "Sustainability",
    categories: "Renewable Integration, Emissions Reduction, Wastewater Management, Impact Mitigation"
  },
  {
    symbol: "Finm",
    name: "Financial Management",
    categories: "Asset Valuation, Revenue Optimization, Risk Assessment, ROI Analysis"
  },
  {
    symbol: "Aimd",
    name: "AI in Midstream",
    categories: "AI Leak Detection, Predictive Maintenance, Route Optimization, Inventory Management"
  }
];